export default [
  {
    path: '',
    component: () => import('@/views/infra/InfraWrapper.vue'),
    children: [
      {
        path: '/infraestructure/question-configuration',
        name: 'questionConfiguration',
        component: () => import('@/views/infra/questionConfig/Main.vue'),
      },
      {
        path: '/infraestructure/question-configuration/:id',
        name: 'questionConfigurationDetail',
        component: () =>
          import('@/views/infra/questionConfig/subViews/detail/Main.vue'),
      },
      {
        path: '/infraestructure/question-configuration/:id/preview',
        name: 'questionConfigurationPreview',
        component: () =>
          import('@/views/infra/questionConfig/subViews/preview/Main.vue'),
      },
    ],
  },
];
